import AxiosInstance from "./api";

export const GeneralLedgerVouchersService = {
  getAccounts: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/general-ledger-vouchers/accounts", {
      params: query,
    });
  },

  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/general-ledger-vouchers", {
      params: query,
    });
  },
};
